// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"fdd1a0c2","749":"6a87e3db"}[chunkId] + ".chunk.js";
};